import React from 'react';
import { Button, Input } from 'antd';

/** 管理后台登录表单（未认证时） */
export default function AdminLoginForm({
  username,
  password,
  loginError,
  onUsernameChange,
  onPasswordChange,
  onLogin
}) {
  return (
    <div style={{ maxWidth: 360, margin: '40px auto', padding: 32, border: '1px solid #ccc', borderRadius: 10, background: '#f7fafd', boxShadow: '0 2px 12px #0001', textAlign: 'center' }}>
      <h2 style={{ marginBottom: 24, color: '#1976d2' }}>管理后台登录</h2>
      <Input
        value={username}
        onChange={e => onUsernameChange(e.target.value)}
        placeholder="管理员用户名"
        style={{ width: 200, height: 36, fontSize: 16, borderRadius: 6, border: '1px solid #bbb', padding: '0 12px', marginBottom: 12 }}
      />
      <br />
      <Input.Password
        value={password}
        onChange={e => onPasswordChange(e.target.value)}
        placeholder="密码"
        style={{ width: 200, height: 36, fontSize: 16, borderRadius: 6, border: '1px solid #bbb', padding: '0 12px', marginBottom: 12 }}
        onKeyDown={e => { if (e.key === 'Enter') onLogin(); }}
      />
      <br />
      <Button
        type="primary"
        onClick={onLogin}
        style={{ width: 200, height: 36, fontWeight: 600, marginBottom: 8 }}
      >
        登录
      </Button>
      {loginError && <div style={{ color: 'red', marginTop: 6 }}>{loginError}</div>}
    </div>
  );
}
